import { WS_URL } from '@constants';

export default (identifier: string, type: 'subscribed' | 'unsubscribed') => {
  const color = { subscribed: 'orange', unsubscribed: 'red' };
  if (process.env.NODE_ENV === 'development') {
    console.info(`%c ${WS_URL} ${identifier}-${type}`, `color: ${color[type]}`);
  }
};
